<template>
  <div id="index">
    <!-- 头部 -->
    <com-header></com-header>

    <!-- 轮播图 -->
    <div
      class="_banner"
      @click="$router.push('/about')"
      v-if="$store.state.screenWidth > 960"
    >
      <el-carousel
        ref="carousel"
        height="100vh"
        arrow="never"
        autoplay
        :interval="10000"
        @mouseenter.native="autoplayHandler"
        @change="changeBanner"
      >
        <el-carousel-item v-for="(item, index) in banner" :key="item.id">
          <img :src="isBannerVisible(index) ? item.thumbnail : placeholder" :key="item.id + '-' + activeIndex" alt="" />
          <div class="_info">
            <div v-if="item.txt">{{ item.txt }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="_m_banner" v-else-if="$store.state.screenWidth <= 960">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="item in banner" :key="item.id">
          <img :src="item.thumbnail" :key="item.id" alt="" />
          <div class="_info">
            <div v-if="item.txt">{{ item.txt }}</div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 项目分布 -->
    <div class="_distribution" v-for="img in distributionImages" :key="img">
      <div class="_map">
        <img
          v-lazy="require('@/assets/images/shouye/' + img)"
          class="_distribution_img"
        />
      </div>
    </div>

    <!-- 底部 -->
    <div class="_footer">
      <ComFooter />
    </div>
  </div>
</template>

<script>
import ComHeader from "../components/common/Header.vue";
import ComFooter from "../components/common/Footer.vue";
export default {
  name: "Index",
  components: {
    ComHeader,
    ComFooter,
  },
  data() {
    return {
      activeIndex: 0,
      placeholder: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      banner: [
        {
          id: 1,
          thumbnail: require('@/assets/images/shouye/lunbo1.png'),
          txt: "BIM 数据底座，专注智慧运维",
        },
        {
          id: 2,
          thumbnail: require('@/assets/images/shouye/shouye1.png'),
          txt: "BIM数字化解决方案",
        },
        {
          id: 3,
          thumbnail: require('@/assets/images/shouye/shouye2.png'),
          txt: "模数同行·万物互联",
        },
        {
          id: 4,
          thumbnail: require('@/assets/images/shouye/shouye3.png'),
          txt: "精准建模·智能分析·全周期服务",
        },
        {
          id: 5,
          thumbnail: require('@/assets/images/shouye/shouye4.png'),
          txt: "基于BIM全过程数智化信息技术集成服务商",
        }
      ],
      distributionImages: ['bim1.png', 'bim2.png', 'bim3.png']
    };
  },
  mounted() {
    setTimeout(() => {
      const items = document.querySelectorAll(".el-carousel__item");
      items.length && items[0].children[1] && items[0].children[1].classList.add("change_top");
    }, 1000);
  },
  methods: {
    changeBanner(val) {
      this.activeIndex = val;
      const items = document.querySelectorAll(".el-carousel__item");
      items.forEach((item, index) => {
        const info = item.children[1];
        if (!info) return;
        if (index === val) {
          info.classList.add("change_top");
        } else {
          info.classList.remove("change_top");
        }
      });
    },
    autoplayHandler() {
      this.$refs.carousel.handleMouseEnter = () => {};
    },
    isBannerVisible(index) {
      const len = this.banner.length;
      const active = this.activeIndex;
      if (len <= 2) return true;
      const diff = Math.abs(index - active);
      return diff <= 1 || diff === len - 1;
    },
  },
};
</script>

<style lang="scss" scoped>
#index {
  ._banner {
    width: 100%;
    height: 100vh;

    ::v-deep .el-carousel {
      .el-carousel__indicators.el-carousel__indicators--horizontal {
        .el-carousel__indicator.el-carousel__indicator--horizontal {
          .el-carousel__button {
            width: 0.63rem;
            height: 0.06rem;
            border-radius: 0.03rem;
            background-color: rgba(255, 255, 255, 0.3);
          }
          &.is-active {
            .el-carousel__button {
              background: #fff;
            }
          }
        }
      }
    }

    .el-carousel__item {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
      .change_top {
        top: 4.38rem !important;
      }
      ._info {
        position: absolute;
        top: 14.38rem;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        padding: 0.2rem 0.5rem;
        background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/banner_txt.png")
          no-repeat;
        background-size: auto;
        transition: all 1.5s ease-in-out;
        div {
          font-size: 0.71rem;
          font-weight: bold;
          color: #fff;
          white-space: nowrap;
          z-index: 99;
          margin-bottom: 0.2rem;
          letter-spacing: 0.08rem;
        }
        span {
          font-size: 0.26rem;
          color: #fff;
          z-index: 99;
          font-weight: bold;
        }
      }
    }
  }

  ._m_banner {
    width: 100%;
    height: 50vw;
    margin-top: $header-offset;

    .my-swipe {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
      ._info {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        text-align: center;
        padding: 0.12rem 0.24rem;
        background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/banner_txt.png")
          no-repeat;
        background-size: 100% 100%;
        max-width: 90%;
        div {
          font-size: 0.28rem;
          font-weight: bold;
          color: #fff;
          white-space: normal;
          z-index: 99;
          margin-bottom: 0.1rem;
          letter-spacing: 0.04rem;
          line-height: 1.4;
        }
      }
    }
  }

  ._distribution {
    background: url('~@/assets/images/opm_bg.png') no-repeat center;
    background-size: cover;

    ._map {
      width: 100%;
      text-align: center;

      ._distribution_img {
        max-width: 100%;
        height: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue